import { isEqual } from 'lodash';
import {
  VariantRequestDto,
  VariantUpdateRequestApiV2Dto,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { generateVariantMetafieldsPayload } from './generateVariantMetafieldsPayload';
import { Variant } from '../../pages/components/Variants/types';
import { getAttributes } from '../shared/helpers';

// TODO:
// This function contains logic that's pretty similar, if not the same
// as the one in getUpdateProductPayload.ts. As well as skipping the rule
// of max-statements.
// This can be refactored to use the same logic for both functions but
// for the sake of clarity, I'll keep them separate for now
// until both Variant and Product entities contain all the fields
// and the corresponding types are completed.
// eslint-disable-next-line max-statements
export const getUpdateVariantPayload = (
  originalVariant: Variant,
  newVariant: VariantRequestDto,
  language: LanguagesType,
): Partial<VariantUpdateRequestApiV2Dto> => {
  const variantToUpdate: Partial<VariantUpdateRequestApiV2Dto> = {};

  if (
    newVariant.price !== null &&
    Number(originalVariant.price) !== Number(newVariant.price)
  ) {
    Object.assign(variantToUpdate, {
      price: newVariant.price,
    });
  }

  if (
    newVariant.locationId &&
    originalVariant.locationId !== newVariant.locationId
  ) {
    Object.assign(variantToUpdate, {
      inventory_levels: [
        {
          location_id: newVariant.locationId || '',
          stock: newVariant.stock || 0,
        },
      ],
    });
  }

  if (
    newVariant.weight !== null &&
    Number(originalVariant.weight) !== Number(newVariant.weight)
  ) {
    Object.assign(variantToUpdate, {
      weight: Number(newVariant.weight),
    });
  }

  if (
    newVariant.width !== null &&
    Number(originalVariant.width) !== Number(newVariant.width)
  ) {
    Object.assign(variantToUpdate, {
      width: Number(newVariant.width),
    });
  }

  if (
    newVariant.height !== null &&
    Number(originalVariant.height) !== Number(newVariant.height)
  ) {
    Object.assign(variantToUpdate, {
      height: Number(newVariant.height),
    });
  }

  if (
    newVariant.depth !== null &&
    Number(originalVariant.depth) !== Number(newVariant.depth)
  ) {
    Object.assign(variantToUpdate, {
      depth: Number(newVariant.depth),
    });
  }

  if (
    newVariant.values &&
    !isEqual(originalVariant.values, newVariant.values)
  ) {
    Object.assign(variantToUpdate, {
      attributes: getAttributes(language, newVariant.values),
    });
  }

  if (newVariant.sku && originalVariant.sku !== newVariant.sku) {
    Object.assign(variantToUpdate, {
      sku: newVariant.sku,
    });
  }

  if (newVariant.barcode && originalVariant.barcode !== newVariant.barcode) {
    Object.assign(variantToUpdate, {
      barcode: newVariant.barcode,
    });
  }

  if (newVariant.mpn && originalVariant.mpn !== newVariant.mpn) {
    Object.assign(variantToUpdate, {
      mpn: newVariant.mpn,
    });
  }

  if (
    newVariant.age_group &&
    originalVariant.ageGroup !== newVariant.age_group
  ) {
    Object.assign(variantToUpdate, {
      age_group: newVariant.age_group,
    });
  }

  if (newVariant.gender && originalVariant.gender !== newVariant.gender) {
    Object.assign(variantToUpdate, {
      gender: newVariant.gender,
    });
  }

  return {
    ...variantToUpdate,
    ...(generateVariantMetafieldsPayload(
      originalVariant.metafields,
      newVariant.metafields,
    ) ?? {}),
  };
};
